import { t } from '#lib/i18n/tranlsator.svelte.ts';
import { formatDateAuto } from '#src/util/format.ts';
import type { SecondarySource, SecondarySourcePlatform } from '#src/types/sources.ts';

export function getHostname(url: string) {
	try {
		return new URL(url).hostname;
	} catch {
		return url;
	}
}

// Proper nouns, not translated
const PLATFORM_NAMES: Record<Exclude<SecondarySourcePlatform, 'web'>, string> = {
	lobbyregister: 'Lobbyregister',
	abgeordnetenwatch: 'Abgeordnetenwatch',
	fragdenstaat: 'FragDenStaat'
};

/** Platform name for typed entities, hostname for web sources and pre-platform-field data */
function getPlatformName(source: SecondarySource): string {
	if (source.platform && source.platform !== 'web') {
		return PLATFORM_NAMES[source.platform];
	}
	return getHostname(source.url);
}

/** "Type · Platform · Retrieved on <date>" — web sources show only "hostname · Retrieved on <date>" */
export function getSecondarySourceSubtitle(source: SecondarySource) {
	const parts =
		source.type === 'web' || source.type === 'fetched_url'
			? [getHostname(source.url)]
			: [t(`secondarySourceType.${source.type}`), getPlatformName(source)];
	if (source.fetched_at) {
		parts.push(
			t('secondarySource.fetchedAt', {
				date: formatDateAuto(source.fetched_at, 'short', true)
			})
		);
	}
	return parts.join(' · ');
}
